import { render, staticRenderFns } from "./print_template_edit.vue?vue&type=template&id=06b1a67b&scoped=true"
import script from "./print_template_edit.vue?vue&type=script&lang=js"
export * from "./print_template_edit.vue?vue&type=script&lang=js"
import style0 from "./print_template_edit.vue?vue&type=style&index=0&id=06b1a67b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1a67b",
  null
  
)

export default component.exports